import { useState } from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import classNames from "classnames";
import ContactCard from "apps/contact/components/contact-card/contact-card";
import TagInput from "components/controls/tag-input";
import { filterOnSearch } from "apps/journeys/utils/helpers";

const ContactList = (props) => {
  const [searchInput, setSearchInput] = useState(undefined);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { assigned, selected } = props;

  let selectedIds = [];
  let filteredContacts = [];

  if (selected && assigned) {
    // Extract the id from selectedContacts
    selectedIds = selected.map((contact) => contact.id);

    // Filter assignedContacts based on selectedIds
    filteredContacts = assigned.filter((contact) => !selectedIds.includes(contact.id));
  } else {
    filteredContacts = assigned;
  }

  const handleSelect = (tag) => {
    props.onSelect(tag);
  };

  const handleTypeahead = async (search) => {
    if (_.isEmpty(search)) search = undefined;
    setSearchInput(search);
    setLoading(!!search);

    if (search) {
      setTimeout(() => {
        let filteredData = { ...filteredContacts };

        filteredData = filterOnSearch(filteredContacts, search);

        setContacts(filteredData);
        setLoading(false);
      }, 200);
    }
  };

  return (
    <div className={classNames("clearfix", props.className)}>
      <TagInput
        options={contacts}
        selected={props.selected}
        placeholder={props.placeholder || "Search for constituents..."}
        focusOnMount={props.focusOnMount}
        loading={loading}
        onEscape={(event) => {
          event.currentTarget.blur();
        }}
        itemContent={(item) => (
          <ContactCard
            contact={item}
            showNameLink={false}
            highlight={searchInput}
            showRemoteId={true}
            showMiddle={true}
          />
        )}
        onTag={handleSelect}
        onType={handleTypeahead}
        disabled={props.disabled}
        handleUnselect={props.handleUnselect}
      />
    </div>
  );
};

ContactList.propTypes = {
  selected: PropTypes.array,
  assigned: PropTypes.array,
  focusOnMount: PropTypes.bool,
  onSelect: PropTypes.func,
  className: PropTypes.string,
  handleUnselect: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

ContactList.defaultProps = {
  focusOnMount: true,
};

export default ContactList;
